import { Component, Input, OnInit } from '@angular/core';
import { DailyChallengeContent } from 'src/app/challenges/services/models/challenges.model';
import { animationFrameScheduler, Observable } from 'rxjs';
import { clamp } from 'lodash';
import { buildProgressAnimation } from '../../../../../_shared/animations/progress-animation';

@Component({
  selector: 'app-challenges-daily-content',
  templateUrl: './challenges-daily-content.component.html',
  styleUrls: ['./challenges-daily-content.component.scss']
})
export class ChallengesDailyContentComponent implements OnInit {
  private static readonly COUNT_ANIM_DURATION = 1500;

  progressCount: Observable<number>[] = [];

  @Input() dailyContents!: DailyChallengeContent[];
  @Input() dailyTarget!: number;

  ngOnInit() {
    this.dailyContents.forEach((dailyItem) => {
      const count = clamp(Math.round(100 * dailyItem.totalMinutes / this.dailyTarget), 0, 100);
      const startTime = animationFrameScheduler.now();

      this.progressCount.push(buildProgressAnimation(count, startTime, ChallengesDailyContentComponent.COUNT_ANIM_DURATION));
    });
  }

  isToday(itemDate: Date) {
    const date = new Date(itemDate);
    const currentDay = new Date();
    return date.toDateString() === currentDay.toDateString();
  }

  getDayProgress(dailyItem: DailyChallengeContent): number {
    return Math.round(100 * dailyItem.totalMinutes / this.dailyTarget);
  }
}
